import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Drawer, IconButton, Typography } from '@mui/material';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { UpdateOtpCard } from 'entities/sendOTP';
import CloseIcon from '@mui/icons-material/Close';
import { OTPDataItemTableType } from 'entities/sendOTP/types';

type UpdateOTPDrawerPropsType = {
  data: OTPDataItemTableType | null;
};
export const UpdateOtpDrawer = ({ data }: UpdateOTPDrawerPropsType) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Изменение способа отправки
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <UpdateOtpCard data={data} />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
